import clsx from "clsx";

import { useExtendedBasketData } from "@chef/state-management/hooks";
import type { WeekYear } from "@chef/types/common";

type DeviationIndicatorProps = WeekYear & {
  className?: string;
  variant: "header" | "tab";
};

export const DeviationIndicator = ({
  className,
  week,
  year,
  variant,
}: DeviationIndicatorProps) => {
  const {
    data: { basketSize, basketHasDeviations },
  } = useExtendedBasketData({
    week,
    year,
  });

  return (
    <span
      className={clsx(
        "bg-grey-1 lg:bg-black text-xxs text-white rounded-full p-2 w-4 h-4 flex items-center justify-center",
        className,
        basketHasDeviations && variant === "tab" && "!bg-primary !text-white",
        basketHasDeviations &&
          variant === "header" &&
          "!bg-white !text-primary",
      )}
    >
      {basketSize}
    </span>
  );
};
